import { saveAs } from 'file-saver';

export const exportDataToCSV = (dataToRender: { [key: string]: string | null; }[], fileName: string) => {
  if (dataToRender.length) {
    const replacer = (_key: string, value: string | null) => (value === null ? '' : value); // specify how to handle null values
    const header = Object.keys(dataToRender[0]);
    const csv = dataToRender.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));

    csv.unshift(header.join(','));
    const csvArray = csv.join('\r\n');

    const blob = new Blob([csvArray], { type: 'text/csv' });

    saveAs(blob, `${fileName}.csv`);
  }
};

export const exportDataToJSON = (dataToRender: object | object[], fileName: string) => {
  const blob = new Blob([JSON.stringify(dataToRender)], {
    type: 'application/json',
  });

  saveAs(blob, `${fileName}.json`);
};

export const prepareDataForDownloading = (columns: string[], items: { [key: string]: any; }[]) => {
  const itemKeys = Object.keys(items[0]);
  const dataToRender: { [key: string]: string | null; }[] = items.map(item => {
    const row: { [key: string]: string | null; } = {};

    columns.forEach(column => {
      const itemColumn = itemKeys.find(key => key === column);

      if (itemColumn) {
        const value = item[column as keyof typeof item];

        if (typeof value !== 'object') {
          row[column] = value;
        }
      }
    });

    return row;
  });

  return dataToRender;
};
